import type { FaireProductEntity } from "../../entity_types/product";

export const p_twfr8hzjjf: FaireProductEntity = {
  token: "p_twfr8hzjjf",
  type: "product",
  name: "Custom 3D Puff Mascot Sweatshirt | School Spirit Wear",
  brandToken: "b_xff5jwej98",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4b1c4fb1db30b8f7edcc4acaa4c23d4e63bd66c3ef9d99ea2897b992e2bd6e01.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1f5bf82792cdcdee63ac0924cafa75fe8090b8d0bb4d0a0e50a9c706bbc4f66.png",
    "https://cdn.faire.com/fastly/08387094185bb7bb90d51ff20c4231cf70675bbde352a4de9666e62d1a4b6580.png",
    "https://cdn.faire.com/fastly/a8b48e1aedcd86a7f1671bfb892f40a416ea4ce31bfd438f9395307b34f1a29a.png",
    "https://cdn.faire.com/fastly/dfc82601c7cc290c922e88bbbed4651796fa18a8a3e55e5c499ccaa4bca53a92.png",
    "https://cdn.faire.com/fastly/8fd024f30ea1f1c42464f09c5e802fd05a1611280d16f5d23e743024412e901f.png",
    "https://cdn.faire.com/fastly/78c77d5457f8e4f2a897ac7e5edf1e79437a924d36dfd063960b0d73bb10b127.png",
    "https://cdn.faire.com/fastly/939e54b1d8ed055c7624da8a8ccbbbba24706f581a3c6a26cc2a94a86ff84d2c.png",
    "https://cdn.faire.com/fastly/362a9f5d9fdb57688f62a564e77ba7d8b50568f47e4721c73a1d4e3621b9c9df.png",
    "https://cdn.faire.com/fastly/1391a662955c52e31f2ab935414b38990fbc2481b2a15fc93d5d9a6db6b13808.png",
  ],
  priceDollars: 34.64,
  description:
    "Turn heads with bold puff embroidery! This custom 3D mascot sweatshirt is the ultimate spirit wear for students, parents, and alumni. Personalize it with your school mascot, name, or team for a standout look you won't find anywhere else.\n\nUnisex Gildan crewneck sweatshirt\n\nAvailable in multiple colors & sizes\n\nChoose your puff thread color\n\nRaised 3D embroidery – high-quality and durable\n\nMade to order – completely customizable\n\nGreat for schools, teams, gifts, and more",
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:35.743Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
